import Image from '~/components/Image';
import PlacementRenderer from '~/domains/mmp/components/PlacementRenderer';
import { usePlacementSearchTopBanners } from '~/domains/mmp/queries';
import { useLinkComponent } from '~/hooks/mobileApp';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';

const SearchTopBanner = () => {
  const { businessId } = useBusinessIdStore();
  const { data: searchTopBannerList = [] } =
    usePlacementSearchTopBanners(businessId);

  const LinkComponent = useLinkComponent();

  if (!searchTopBannerList.length) return <></>;

  const { name, bannerUrl, imageUrl, adGroupId, creativeId } =
    searchTopBannerList[0];

  return (
    <PlacementRenderer
      adGroupId={adGroupId}
      creativeId={creativeId}
      name={name}
    >
      <LinkComponent className="block" href={bannerUrl!}>
        {imageUrl && (
          <Image src={imageUrl} width={1080} height={300} alt={name} />
        )}
      </LinkComponent>
    </PlacementRenderer>
  );
};
export default SearchTopBanner;
